import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ChevronRight, Package } from "lucide-react";
import { api } from "../lib/api";

/**
 * Red banner shown on the admin dashboard when one or more cleaning
 * products are about to run out at "high" consumption rate.
 * Polls every 60s. Hides itself when nothing's low.
 */
export default function LowStockBanner() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    async function tick() {
      try {
        const { data } = await api.get("/admin/products/low-stock?threshold_days=7");
        if (alive) setItems(data.items || []);
      } catch { /* fail-quiet */ }
    }
    tick();
    const id = setInterval(tick, 60000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  if (items.length === 0) return null;

  const top = items.slice(0, 3);
  const more = items.length - top.length;

  return (
    <Link to="/admin/produtos"
          className="lux-card p-5 flex items-start gap-4 border-[#ef4444]/60 bg-[#ef4444]/5 hover:bg-[#ef4444]/10 transition-colors group"
          data-testid="low-stock-banner">
      <span className="relative shrink-0">
        <span className="absolute inset-0 rounded-full bg-[#ef4444] animate-ping opacity-50" />
        <span className="relative w-12 h-12 rounded-full bg-[#ef4444] flex items-center justify-center text-white">
          <AlertTriangle size={22} />
        </span>
      </span>
      <div className="flex-1 min-w-0">
        <div className="eyebrow text-[#ef4444] mb-1 animate-pulse flex items-center gap-2">
          <Package size={11} /> Produtos a esgotar
        </div>
        <div className="font-display text-lg md:text-xl mb-2">
          {items.length === 1
            ? "1 produto vai esgotar nos próximos 7 dias"
            : `${items.length} produtos vão esgotar nos próximos 7 dias`}
        </div>
        <ul className="space-y-0.5 text-xs text-[#a0b2af]">
          {top.map(it => (
            <li key={it.id} data-testid={`low-stock-item-${it.id}`}>
              · <span className="text-[#fdfbf7]">{it.name}</span> — {it.stock}{it.unit_label} ·
              {" "}<span className="text-[#ef4444]">{it.days_left} dias</span> no nível alto
            </li>
          ))}
          {more > 0 && (
            <li className="text-[#a0b2af] italic">+ {more} outros</li>
          )}
        </ul>
      </div>
      <ChevronRight size={20} className="text-[#ef4444] shrink-0 group-hover:translate-x-1 transition-transform" />
    </Link>
  );
}
